// extracted by mini-css-extract-plugin
export default {"imageWithBackup":"_tdvDICiWI9s_deSUHXq"};